// extracted by mini-css-extract-plugin
export var contentBody = "_b3-9";
export var headerImage = "_b3-2";
export var imageButton = "_b3-7";
export var imageButtonIcon = "_b3-8";
export var imageHeader = "_b3-4";
export var imageHeaderText = "_b3-5";
export var imageOverlay = "_b3-3";
export var imageTitle = "_b3-6";
export var imageWrapper = "_b3-1";
export var taskList = "_b3-a";
export var widget = "_b3-0";